import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type {
  OrdersBulkUploadSlice,
  OrdersBulkUploadFilters,
} from "./ordersBulkUploadTypes.ts";

const initialState: OrdersBulkUploadSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: { search: "" },
  sort: {
    key: "updatedAt",
    order: "desc",
  },
};

export const ordersBulkUploadSlice = createSlice({
  name: "ordersBulkUpload",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<OrdersBulkUploadSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<OrdersBulkUploadSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [
          filterType: keyof OrdersBulkUploadFilters,
          filterValue: string | undefined,
        ]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<OrdersBulkUploadSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  ordersBulkUploadSlice.actions;

export const selectPage = (state: RootState) => state.ordersBulkUpload.page;
export const selectRowsPerPage = (state: RootState) =>
  state.ordersBulkUpload.rowsPerPage;
export const selectFilter = (state: RootState) => state.ordersBulkUpload.filter;
export const selectSort = (state: RootState) => state.ordersBulkUpload.sort;
export default ordersBulkUploadSlice.reducer;
